import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { readTheme, applyTheme } from './lib/theme'

// Before render, not inside a component: a dark user should never see the
// light theme flash while React boots.
applyTheme(readTheme())

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<React.StrictMode><App /></React.StrictMode>)
